import { _ } from "libs";
import React, { Component } from "react";
import Select from "../../select";
import { Ratings, NationalRating, NationalRatingRating, OfficialRating } from "../../../types";
import SwissCountryFields from "./nationalRatings/switzerland";
import RatingSelect from "./ratingSelect";

type Props = {
	country: any;
	rating: any;
	ratings: Ratings;
	officialRating: OfficialRating;
	onChange: Function;
	userId: string;
	onResetClicked;
};

type ValueLabelPair = {
	value: string;
	label: string;
};

type State = {
	country: string | null;
	countries: ValueLabelPair[];
	rating: string | null;
	officialRating: OfficialRating | null;
	ratings: ValueLabelPair[];
};

export class NationalRatingInput extends Component<Props, State> {
	constructor(props: Props) {
		super(props);

		const countries =
			props.ratings?.nationalRatings?.map((rating: NationalRating) => {
				return {
					value: rating.countryCode,
					label: _(`countryCode.${rating.countryCode}`),
				};
			}) || [];

		const country = this.props.country ? this.props.country : countries[0].value;
		const ratings = this.getNationalRatings(country);

		this.state = {
			countries,
			country: country,
			officialRating: this.props.officialRating,
			ratings,
			rating: this.props.rating,
		};
	}

	getNationalRatings = (countryCode: string) => {
		for (let rating of this.props.ratings.nationalRatings) {
			if (rating.countryCode === countryCode) {
				return this.mapRatingsToValues(rating.ratings);
			}
		}
	};

	mapRatingsToValues = (ratings: NationalRatingRating[]) => {
		return ratings.map(({ ratingCode, ITN }) => {
			return {
				value: ratingCode,
				label: ratingCode, //_("onboarding.ratingCode", null, { ratingCode, ITN }),
			};
		});
	};

	onCountryChange = (country) => {
		const ratings = this.getNationalRatings(country);
		this.setState({ country, ratings, rating: ratings[0].value });
	};

	onRatingChange = (rating, officialRating?: OfficialRating) => {
		this.setState({ rating, officialRating });
	};

	onSaveClicked = () => {
		this.props.onChange({
			country: this.state.country,
			rating: this.state.rating,
			officialRating: this.state.officialRating,
		});
	};

	render() {
		return (
			<div className="form nationalRatingForm">
				<div className="field medium">
					<label>{_("form.country.label")}</label>
					<Select
						prompt={null}
						value={this.state.country}
						items={this.state.countries}
						onChange={this.onCountryChange}
					/>
				</div>
				<CountryFields
					country={this.state.country}
					ratings={this.state.ratings}
					onRatingChange={this.onRatingChange}
					rating={this.state.rating}
					officialRating={this.state.officialRating}
					userId={this.props.userId}
					onResetClicked={this.props.onResetClicked}
					onSaveClicked={this.onSaveClicked}
				/>
				<div className="note ITNrepresentation" />
			</div>
		);
	}
}

class CountryFields extends Component<{
	country: string;
	onRatingChange: any;
	rating: any;
	ratings: Array<any>;
	officialRating?: OfficialRating;
	userId: string;
	onResetClicked;
	onSaveClicked;
}> {
	constructor(props) {
		super(props);
	}

	render() {
		const country = this.props.country || "CH";
		switch (country.toUpperCase()) {
			case "CH":
				return (
					<SwissCountryFields
						country={this.props.country}
						onRatingChange={this.props.onRatingChange}
						rating={this.props.rating}
						ratings={this.props.ratings}
						officialRating={this.props.officialRating}
						userId={this.props.userId}
						onResetClicked={this.props.onResetClicked}
						onSaveClicked={this.props.onSaveClicked}
					/>
				);
			default:
				return (
					<>
						<div className="field medium">
							<label>{_("form.rating.label")}</label>
							<RatingSelect
								country={this.props.country}
								onRatingChange={this.props.onRatingChange}
								rating={this.props.rating}
								ratings={this.props.ratings}
							/>
						</div>
						<button className="button submit" onClick={this.props.onSaveClicked}>
							{_("onboarding.nationalRating.btnSave.label")}
						</button>
					</>
				);
		}
	}
}

export default NationalRatingInput;
